import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { loginUser, registerUser } from "../../controller/users/usersController";
import errorHandler from "../../utils/errorHandler";
import {
    addCredObjToLocalStorage,
    addLmsCredObjToLocalStorage,
    getActiveAuthSessionType,
    getActiveCredObjFromLocalStorage,
    removeCredObjsFromLocalStorage,
} from "../../utils/localStorage";

const initialState = {
  isLoading:false,
  isSideBarOpen:false,
  authSessionType:getActiveAuthSessionType(),
  credObj:getActiveCredObjFromLocalStorage()
};

// export const logoutUser = createAsyncThunk(
//     'user/logoutUser', async (user, thunkAPI) => {
//         try {
//             // const response = await fetchAPI.post('/auth/logout', user); TODO
//             let loggedOut = {success: true}
//             return loggedOut;    
//         } catch (error) {
//             let message = error.response.data.error;
//             return thunkAPI.rejectWithValue(message);
//         }
//     }
// );
const authSlice = createSlice({
    name:'credObj',
    initialState,
    reducers:{
        toggleSideBar:(state) => {
            state.isSideBarOpen = !state.isSideBarOpen;
        },
        setCredObj: (state, { payload }) => {
            state.credObj = payload;
            state.authSessionType = 'regular';
            addCredObjToLocalStorage(payload);
        },
        setLmsCredObj: (state, { payload }) => {
            state.credObj = payload;
            state.authSessionType = 'lms';
            addLmsCredObjToLocalStorage(payload);
        },
        logoutUser: (state) => {
            state.credObj = null;
            state.authSessionType = 'regular';
            state.isSideBarOpen = false;
            removeCredObjsFromLocalStorage();
        }
    },
    extraReducers: {
        [registerUser.pending]:(state) => {
            state.isLoading = true;
        },
        [registerUser.fulfilled]:(state, {payload}) => {
            const { token, refreshToken } = payload;
            const credObj = {
                token,
                refreshToken
            };
            state.isLoading = false;
            state.credObj = credObj;
            state.authSessionType = 'regular';
            addCredObjToLocalStorage(credObj);
            toast.success("Registration successfull!");
        },
        [registerUser.rejected]:(state, {payload}) => {
            state.isLoading = false;
            errorHandler(payload);
        },
        [loginUser.pending]:(state) => {
            state.isLoading = true;
        },
        [loginUser.fulfilled]:(state, {payload}) => {
            const { token, refreshToken } = payload;
            const credObj = {
                token,
                refreshToken
            };
            state.isLoading = false;
            state.credObj = credObj;
            state.authSessionType = 'regular';
            addCredObjToLocalStorage(credObj);
            toast.success("Login Successfull");
        },
        [loginUser.rejected]:(state, {payload}) =>  {
            state.isLoading = false;
            errorHandler(payload);
        }
    }
});
export const { toggleSideBar, setCredObj, setLmsCredObj, logoutUser } = authSlice.actions;
export default authSlice.reducer;
